module.exports = function getResource(label) {
    const resources = {
        anErrorOccurredPleaseTryAgainLater: 'Un problème est survenu. Veuillez essayer de nouveau.',
        error: 'Erreur',
        ok: 'OK',
        passkeyAuthenticationErrorMessage: 'Une erreur s’est produite lors de l’ouverture de la session. Veuillez utiliser votre courriel et votre mot de passe pour vous connecter.',
        passkeyAccountDeactivatedMessage: 'Pour réactiver le compte, veuillez appeler notre équipe du service à la clientèle au 1-877-SEPHORA (1-877-737-4672) ou clavarder avec nos agent(e)s.',
        passkeyFromYourAccount: 'clé d’accès de votre compte.',
        passkeyRemoved: 'Clé d’accès supprimée',
        pleaseConfirmYouWantToRemove: 'Voulez-vous vraiment supprimer?',
        removePasskey: 'Supprimer la clé d’accès',
        removePasskeysTitle: 'Supprimer la clé d’accès?',
        yourPasskeyHaveBeenRemoved: 'Votre clé d’accès a été supprimée.',
        passkeyLoginError: 'Nous ne sommes pas en mesure de vous connecter pour l’instant. Veuillez essayer de nouveau.'
    };
    return resources[label];
};
